import { createSelector } from '@ngrx/store';

import { restrictionsLimit } from '../restrictionsLimit';

export const hasExceededProductsLimit = createSelector(restrictionsLimit, (reports) => {
    if (!reports) return false;

    return reports.some((report) => report.isExceeded === true);
});
